import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { useAppContext } from '../../../context/AppContext';
import { fetchData } from '../../../services';
import { useState } from 'react';
import Modal from '../../helpers/Modal';
export const SendQuoteForm = ({ quote, setQuotes }) => {
    const { token, base_url, user } = useAppContext();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [recipientEmail, setRecipientEmail] = useState( user?.is_super_admin ? '' : user.email);
    
    const isSuperAdmin = user?.is_super_admin === true;

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        if (isSubmitting) return; // Prevent multiple submissions
        
        setIsSubmitting(true);

        try {
            console.log('Sending quote:', quote.qbo_data.Id);
            const response = await fetchData(token, `${base_url}/apis/billing/send/${quote.qbo_data.Id}/${recipientEmail}`);
            console.log('Quote sent successfully:', response);
            
            // Show success alert
            window.showAlert(200, 'Quote sent successfully!');
            
            setIsModalOpen(false);
        } catch (error) {
            console.error('Error sending quote:', error);
            
            // Show error alert based on error type
            if (error.status === 404) {
                window.showAlert(404, 'Quote not found');
            } else if (error.status >= 400 && error.status < 500) {
                window.showAlert(error.status, 'Failed to send quote. Please check your input.');
            } else {
                window.showAlert(500, 'Failed to send quote. Please try again.');
            }
        } finally {
            setIsSubmitting(false);
        }
    };

    const sendQuoteForm = (
        <div>
            <h2>Send Quote</h2>
            <p>Would you like to send this quote via email?</p>
            <p><strong>Quote: {quote?.quote_number}</strong></p>
            {isSuperAdmin ? (
                <p>Please enter the email address of the person you would like to send the quote to.</p>
            ) : (
                <p>This will email you a copy of the quote.</p>
            )}
            
            {isSuperAdmin && (
                <div className="form-group">
                    <label htmlFor="recipientEmail">Recipient Email Address:</label>
                    <input
                        type="email"
                        id="recipientEmail"
                        value={recipientEmail}
                        onChange={(e) => setRecipientEmail(e.target.value)}
                        placeholder="Enter email address"
                        className="form-input"
                        disabled={isSubmitting}
                        required
                    />
                </div>
            )}
            
            <div className="form-actions">
                <button
                    type="button"
                    onClick={() => setIsModalOpen(false)}
                    className="btn btn-secondary"
                    disabled={isSubmitting}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    onClick={handleSubmit}
                    className="btn btn-primary"
                    disabled={isSubmitting || (isSuperAdmin && !recipientEmail)}
                >
                    {isSubmitting ? (
                        <>
                            <FontAwesomeIcon icon={faSpinner} spin /> Sending...
                        </>
                    ) : (
                        'Send Quote'
                    )}
                </button>
            </div>
        </div>
    );

    return (
        <>
            <button 
                onClick={() => setIsModalOpen(true)} 
                className="btn btn-action btn-secondary"
                title="Send Quote"
            >
                <FontAwesomeIcon icon={faPaperPlane} />  Send Quote
            </button>
            {isModalOpen && (
                <Modal form={sendQuoteForm} setIsModalOpen={setIsModalOpen} />
            )}
        </>
    );
};
